export const breakingNews: string[] = [
  "头部带货直播间陷入'虚假成分标注'争议，品牌方凌晨发布说明回应",
  "某选秀综艺二次公演片段被曝'恶意剪辑'，制作组承诺公开完整母带",
  "新消费茶饮品牌被指'含糖量翻标'，质检部门已介入复核",
  "网红孵化机构被曝'霸王合同'，多位达人陆续发声",
  "电子烟品牌旧代言截图被翻出，当事人回应称'早已解约'",
  "手游厂商深夜更新未成年人防沉迷规则，冲上热搜",
];

export const focusStory = {
  tag: "今日焦点 · 持续发酵",
  title: "某头部带货直播间'成分标注'争议：从一条旧视频到全网追问",
  lead: "一条发布于两年前的直播切片被重新翻出，主播称某护肤品'零防腐剂、孕妇可用'，随后网友晒出配料表截图质疑标注不实。事件在数小时内冲上热搜，品牌方、质检口径与主播此前声明出现多个版本，进展仍在变化。",
  statusText: "最新动态 · 已过去 4 小时",
  views: "286万",
  comments: "1.4万",
  updateCount: "已更新 6 条新进展",
  image:
    "https://readdy.ai/api/search-image?query=abstract%20editorial%20composition%20of%20a%20large%20magnifying%20glass%20over%20stacked%20newspaper%20articles%20and%20text%20fragments%2C%20warm%20ivory%20paper%20texture%2C%20vermilion%20red%20and%20amber%20ink%20accents%2C%20dramatic%20soft%20shadow%2C%20newsroom%20investigation%20theme%2C%20high%20contrast%2C%20minimalist%20editorial&width=1600&height=900&seq=hero-focus-2026x1&orientation=landscape",
};

export type FeedStatus = "发酵中" | "已回应" | "已辟谣" | "新进展";

export interface FeedEvent {
  id: string;
  category: string;
  title: string;
  summary: string;
  status: FeedStatus;
  heat: string;
  time: string;
  replies: string;
  tags: string[];
}

export const feedEvents: FeedEvent[] = [
  {
    id: "e01",
    category: "直播带货",
    title: "头部主播'零添加'宣传翻车，品牌方称属'表述歧义'",
    summary: "网友对比配料表后指出主播宣称与实际标注不符，品牌客服口径多次修改，目前原产地与送检报告均未完全公开。",
    status: "发酵中",
    heat: "286万",
    time: "2 小时前",
    replies: "1.4万",
    tags: ["直播带货", "成分标注", "辟谣"],
  },
  {
    id: "e02",
    category: "综艺娱乐",
    title: "选秀节目公演片段被质疑'恶意剪辑'，选手粉丝要求放母带",
    summary: "节目正片与预告字幕存在时间线出入，多位参赛者下场表态，制作方回应称将在一周内公开完整版。",
    status: "已回应",
    heat: "197万",
    time: "5 小时前",
    replies: "9200",
    tags: ["综艺", "剪辑争议"],
  },
  {
    id: "e03",
    category: "新消费",
    title: "网红茶饮品牌'低糖'实为'半糖'？第三方检测结果待公布",
    summary: "消费者送检显示含糖量与宣传相差约三成，品牌称系'测量口径不同'，门店已悄悄更新菜单标注。",
    status: "新进展",
    heat: "153万",
    time: "9 小时前",
    replies: "6800",
    tags: ["茶饮", "送检", "健康"],
  },
  {
    id: "e04",
    category: "商业动向",
    title: "某 MCN 机构被曝'天价违约金'条款，多位达人晒合同细节",
    summary: "达人曝光解约需赔'过去三年全部收益'的条款截图，机构连夜发声明称合同可协商，律师解读观点不一。",
    status: "发酵中",
    heat: "132万",
    time: "12 小时前",
    replies: "5100",
    tags: ["MCN", "合同", "打工人"],
  },
  {
    id: "e05",
    category: "娱乐人物",
    title: "旧代言截图被翻出：当事人回应'早于争议产品上线前已解约'",
    summary: "一张两年前的商务截图被重新传播，当事人用完整合同时间线回应，多名业内人士表示'切片需看上下文'。",
    status: "已辟谣",
    heat: "98万",
    time: "1 天前",
    replies: "4300",
    tags: ["代言", "辟谣", "时间线"],
  },
  {
    id: "e06",
    category: "游戏科技",
    title: "手游深夜更新防沉迷规则，未成年人充值退款通道一度拥堵",
    summary: "新规则上线后家长申请退款激增，客服回应'审核将分批处理'，社区对规则细节仍有大量讨论。",
    status: "已回应",
    heat: "86万",
    time: "1 天前",
    replies: "3600",
    tags: ["游戏", "防沉迷", "退款"],
  },
  {
    id: "e07",
    category: "社会话题",
    title: "'上门喂宠'兼职遇糟心事：订单被临时砍单，平台承诺补齐差价",
    summary: "一位兼职喂宠师晒出被临时取消的订单，平台方回应已启动保障赔付，事件引发对灵活用工权益的关注。",
    status: "新进展",
    heat: "64万",
    time: "2 天前",
    replies: "2100",
    tags: ["灵活用工", "平台", "兼职"],
  },
  {
    id: "e08",
    category: "品牌公关",
    title: "某美妆品牌翻车文案被网友逐句回应，官博致歉并更换物料",
    summary: "宣传文案被指'踩雷'，品牌一天内两次改文案仍未平息，最终公开致歉并下架相关物料与广告位。",
    status: "已回应",
    heat: "51万",
    time: "2 天前",
    replies: "1800",
    tags: ["美妆", "公关", "致歉"],
  },
];

export const eventCategories = [
  {
    name: "直播带货",
    icon: "ri-live-line",
    desc: "带货翻车、选品争议、售后口径",
    count: 128,
    base: "primary",
  },
  {
    name: "综艺娱乐",
    icon: "ri-clapperboard-line",
    desc: "剪辑争议、剧本质疑、幕后花絮",
    count: 96,
    base: "accent",
  },
  {
    name: "新消费",
    icon: "ri-cup-line",
    desc: "配料标注、测评送检、健康宣称",
    count: 74,
    base: "secondary",
  },
  {
    name: "商业动向",
    icon: "ri-briefcase-4-line",
    desc: "MCN 合同、用工争议、行业潜规则",
    count: 61,
    base: "accent",
  },
  {
    name: "娱乐人物",
    icon: "ri-user-star-line",
    desc: "旧料翻出、代言时间线、辟谣追踪",
    count: 142,
    base: "primary",
  },
  {
    name: "游戏科技",
    icon: "ri-gamepad-line",
    desc: "新规落地、退款通道、平台规则",
    count: 53,
    base: "secondary",
  },
  {
    name: "社会话题",
    icon: "ri-megaphone-line",
    desc: "灵活用工、消费维权、公共议题",
    count: 88,
    base: "primary",
  },
  {
    name: "品牌公关",
    icon: "ri-message-3-line",
    desc: "文案翻车、致歉节奏、舆情复盘",
    count: 67,
    base: "accent",
  },
];

export const timelineCase = {
  eventTitle: "『成分标注』争议 · 完整时间线还原",
  intro:
    "把一个看似简单的事件拆开看，你会发现信息是分阶段释放的。以下是截至目前的公开进展梳理，均标注来源阶段与核实状态。",
  steps: [
    {
      time: "两年前",
      head: "旧切片源起",
      text: "一段主播宣传'零防腐剂、孕妇可用'的直播切片首次发布，彼时未引起大规模讨论。",
      state: "原始素材",
    },
    {
      time: "事件第 1 小时",
      head: "旧料被重新挖掘",
      text: "有网友结合该产品当时配料表逐条对比，截图开始在多个社区流传，话题标签快速建立。",
      state: "二次传播",
    },
    {
      time: "事件第 6 小时",
      head: "品牌首版回应",
      text: "品牌客服称'属表述歧义，未提及防腐剂成分是否完全为零'，该口径被网友认为与切片不符。",
      state: "口径一",
    },
    {
      time: "事件第 24 小时",
      head: "官方声明与送检计划",
      text: "品牌发布长声明，承诺公开批次送检报告并接受第三方复核，声明未直接回应主播角色。",
      state: "正式回应",
    },
    {
      time: "追踪中",
      head: "待核实信息清单",
      text: "送检报告出具时间、主播方声明、历史直播回放是否完整保留三项，均在持续跟进中。",
      state: "待更新",
    },
  ],
};

export const responses = [
  {
    source: "品牌方 · 正式声明",
    tone: "回应中",
    text: "已成立专项小组，将在一个工作日内公开该批次第三方送检报告，并对历史宣传物料进行内部复核。",
    date: "事件第 24 小时",
  },
  {
    source: "当事人主播 · 团队",
    tone: "待回应",
    text: "暂未就切片内容单独回应，其团队表示'正在核实历史直播语境，不排除走法律途径维护名誉'。",
    date: "事件第 12 小时",
  },
  {
    source: "质检口径",
    tone: "进行中",
    text: "相关监管部门表示已关注网络反映，将按程序对涉事批次开展抽检，结果以正式通告为准。",
    date: "事件第 20 小时",
  },
  {
    source: "第三方科普博主",
    tone: "独立观点",
    text: "多位成分科普博主提醒：'零防腐'与'零刺激'是不同概念，判断需结合完整配料与使用场景，不宜单凭切片。",
    date: "持续补充",
  },
];

export const rankings = [
  { title: "'成分标注'争议持续发酵，品牌承诺公开送检", heat: "286万", trend: "up", delta: "+62%" },
  { title: "选秀节目剪辑风波，制作组承诺放完整母带", heat: "197万", trend: "up", delta: "+45%" },
  { title: "茶饮'低糖'送检结果揭晓在即", heat: "153万", trend: "up", delta: "+38%" },
  { title: "MCN 天价违约金条款引达人集体发声", heat: "132万", trend: "steady", delta: "+9%" },
  { title: "旧代言切片辟谣，时间线成关键", heat: "98万", trend: "steady", delta: "+5%" },
  { title: "游戏防沉迷新规退款通道拥挤", heat: "86万", trend: "down", delta: "-12%" },
  { title: "上门喂宠被砍单，平台承诺赔付", heat: "64万", trend: "up", delta: "+21%" },
];

export const principles = [
  {
    icon: "ri-time-line",
    title: "先理时间线，再下结论",
    text: "我们不追碎片截图，而是把每个事件按时间先后归档，先有'发生了什么、顺序如何'，再谈'意味着什么'。",
  },
  {
    icon: "ri-focus-3-line",
    title: "多源交叉，标注口径",
    text: "同一说法出现多个版本时，我们会并列呈现并标注来源方与当前口径，不替你预判谁在说谎。",
  },
  {
    icon: "ri-goblet-line",
    title: "辟谣与反转，同样追踪",
    text: "新进展不只等于'坐实'。当当事人回应、官方声明或第三方检测推翻旧说法时，我们会第一时间同步更新，避免追错方向。",
  },
  {
    icon: "ri-eye-off-line",
    title: "核实优先，克制扩散",
    text: "未经验证、涉及隐私或会误导传播的信息，我们宁可不发，也不做未经核实的二次传播。",
  },
];

export const testimonials = [
  {
    name: "追热点爱好者",
    role: "常驻用户",
    text: "以前刷到反转新闻总是一头雾水，现在看事件脉络和时间线就清楚多了，能快速知道哪些还悬而未决。",
  },
  {
    name: "内容编辑从业者",
    role: "媒体同行",
    text: "他们把各方回应和待核实清单整理得很清晰，我做选题背景调研时省了很多时间。",
  },
  {
    name: "消费者",
    role: "普通网友",
    text: "成分标注那件事我本来只想吃瓜，结果看完时间线还真学到了怎么看配料表和送检报告，挺有收获。",
  },
];

export const faqItems = [
  {
    q: "'沸点追踪'到底在追踪什么？",
    a: "我们专注整理互联网上正在发生的热点事件、争议与'最新进展'，把散落在各个平台的截图、声明、回应，按时间顺序整理成可回溯的事件脉络，方便读者快速掌握事件目前处于什么阶段、还有哪些关键信息悬而未决。",
  },
  {
    q: "'新进展'和'新后续'有什么区别？",
    a: "两者都指事件的信息更新。本站约定：'新进展'侧重事件本身出现的突破或变化（如官方声明、检测报告、当事人回应）；'新后续'更偏向事件带出的延伸话题（如引发的行业讨论、规则调整、同类案例）。追踪时两者会并列展示，避免混淆。",
  },
  {
    q: "一条新闻从'发酵中'到'已辟谣'是如何判定的？",
    a: "判定基于可公开核实的信息源：'发酵中'指讨论规模上升但关键方尚未充分回应；'已回应'指当事人、品牌或官方已给出明确说法；'已辟谣'指新公开的证据或声明推翻了此前主要说法。状态会随新信息动态调整，并非一成不变。",
  },
  {
    q: "你们会跟踪所有争议事件吗？怎么保证不追错方向？",
    a: "我们优先跟踪讨论热度高、或涉及消费者权益/公共利益的议题。跟踪遵循'先理时间线、多源交叉、辟谣同步更新'的原则，并为每条新进展标注来源阶段，若出现反转会第一时间改标并补充说明。",
  },
  {
    q: "如何理解'各方回应'里的多种口径？",
    a: "同一事件里，品牌、当事人、监管、第三方往往口径不一甚至互相矛盾。我们把各方说法并列列出并注明时间，不替你判断谁绝对正确，而是把矛盾点摆清楚，让读者结合完整时间线自行判断，后续有正式结论会再同步。",
  },
  {
    q: "如何提交事件线索或纠错？",
    a: "欢迎通过页面底部的'订阅与线索征集'表单提交线索或指出信息偏差。请尽量附上可核实的时间、来源与链接，我们会按核实优先级处理，确认后会补充进对应事件脉络。",
  },
];